import { Expose } from "class-transformer";
import { BaseModel } from "src/shared/models/base.model";

export class EpsContractor extends BaseModel {
    @Expose() contractorId = -1;
    @Expose() name = "";
}
